'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _signOff = require('./sign-off.html');

var _signOff2 = _interopRequireDefault(_signOff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _signOff2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    onSignedOff: '&',
    units: '<',
    chosenUnits: '<',
    isTreat: '<'
  },
  controller: function () {
    function SignOffComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, SignOffComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(SignOffComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.onSignedOff(this.EventEmitter({
          signature: this.signature
        }));
      }
    }]);

    return SignOffComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/sign-off/sign-off.component.js